import { styled } from "@mui/material";

export const ContainerDetails = styled("div")(() => ({
  width: "57.5%",
  background: "#FFF",
  borderRadius: "12px",
  padding: "1.5rem 1rem",
  border: "1px solid #F2F4F7",
}));

export const ContainerNoTasks = styled("div")(
  ({ applyBoxShadow }: { applyBoxShadow?: boolean }) => ({
    boxShadow: applyBoxShadow
      ? "2px 1px 5px rgba(152, 162, 179, 0.15), 0px 4px 10px rgba(48, 140, 219, 0.05)"
      : "",
    borderRadius: "12px",
    border: "1px solid #E4E7EC",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "& img": {
      width: "11.25rem",
      height: "9rem",
    },
    "& div": {
      width: "25rem",
      height: "6rem",
      textAlign: "center",
      "& h2": {
        fontWeight: 500,
        fontSize: "1.5rem",
        lineHeight: "2rem",
        margin: "0",
        color: "#475467",
        fontFamily: "Manrope",
      },
      "& p": {
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: "1.5rem",
        color: "#465869",
        fontFamily: "Manrope",
      },
    },
  })
);

export const ContainerTextNoTasks = styled("div")(() => ({
  width: "25rem",
  height: "6rem",
  textAlign: "center",
  fontFamily: "Manrope",
  "& h2": {
    fontWeight: 500,
    fontSize: "1.5rem",
    lineHeight: "2rem",
    margin: "0",
    color: "#475467",
  },
  "& p": {
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
  },
}));

export const ContainerBasicDetails = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
  height: "100%",
}));

export const SeeFullDetailsStyle = styled("div")(() => ({
  padding: 0,
  margin: 0,
  "& button": {
    padding: 0,
    margin: 0,
  },
}));

export const ReferenceOrderStyle = styled("span")(
  ({ color, weight }: { color: string; weight: number }) => ({
    color,
    fontFamily: "Manrope",
    fontSize: "0.875rem",
    fontWeight: weight,
    lineHeight: "1.3rem",
  })
);
